package com.eladfinish.bible.contest.domain.catalog

data class BookData(
    val hebrew: String,
    val trans: String, // transliteration
    val english: String,
    val numberOfChapters: Int,
)
